import Choices from "choices.js";

$(document).ready(function () {
    const defaultCurrency = $('.button-currency._active').data('currency');
    localStorage.setItem("currentCurrency", defaultCurrency);
    const $csrf_token = $(".controls__description").find('input[name="csrfmiddlewaretoken"]').val();

    $.ajax({
        url: `${window.location.origin}/api/v1/settings/exchange-rate/`,
        type: 'GET',
        headers:{"X-CSRFToken": $csrf_token},
        processData: false,
        contentType: false,
        cache: false,
        success: function(response) {
            localStorage.setItem("rates", JSON.stringify({
                byn: response.rates.eur_byn,
                usd: response.rates.eur_usd,
                rub: response.rates.eur_rub,
            }));
        },
        error: function(error) {
            console.log(error);
            localStorage.setItem("rates", JSON.stringify({
                byn: 0,
                usd: 0,
                rub: 0,
            }));
        },
    });
});

$('.wrapper').removeClass('load');

let myCookie = Cookies.get("user");

if(!myCookie){
    $('.cookies-block').find('aside').addClass('custom-transition');
    $('.cookies-block').addClass('active');
}

$(document).on('click', (e) => {
    const action = $(e.target).data('actionMenu');
    if ($(e.target).hasClass('action-menu') && $(e.target).hasClass('active')) {
        $('.action-menu').removeClass('active');
        $('html').removeClass('no--scroll');
    }
    if ($(e.target).hasClass('fullscreen-action-menu') && $(e.target).hasClass('active')) {
        $('.fullscreen-action-menu').removeClass('active');
        $('.fullscreen-action-menu').find('.image-wrapper__img').removeClass('_active');
        $('html').removeClass('no--scroll');
    }

    if (action) {
        $('html').toggleClass('no--scroll', action !== 'close');
        if (action !== 'close') {
            $(`.action-menu[data-action=${action}]`).addClass('active');
            $(`.action-menu[data-action=${action}]`).find('aside').addClass('custom-transition');
            if (action === 'fullscreen-gallery') {
                $('.fullscreen-action-menu').addClass('active');
                $('.fullscreen-action-menu').find('.image-wrapper__img').first().addClass('_active');
            }
        } else {
            $('.action-menu').removeClass('active');
            $('.fullscreen-action-menu').removeClass('active');
            $('.fullscreen-action-menu').find('.image-wrapper__img').removeClass('_active');
            setTimeout(() => {
                $('.action-menu').find('.main-wrapper').removeClass('_shown-second');
                $('.action-menu').find('.button-back').css('display', 'none');
            }, 500);
        }
    }
    if ($(e.target).hasClass('cookies-close')) {
        e.preventDefault()
        $('.action-menu').removeClass('active');
        $('html').removeClass('no--scroll');
        Cookies.set('user', 'true',{
            expires:365
        });
        setTimeout(() => {
            $('.cookies-block').find('aside').removeClass('custom-transition');
        }, 1000);
    }
    if ($(e.target).hasClass('button-back')) {
        $(e.target).closest('.action-menu').find('.main-wrapper').removeClass('_shown-second');
        $(e.target).css('display', 'none');
    }
    if ($(e.target).hasClass('settings-btn')) {
        e.preventDefault()
        $(".settings-btn").removeClass("_active");
        $(e.target).addClass("_active");
        filter();
    }

    if (
      $('.select-cart-size').find('.custom-select-name.active').length > 0 ||
      $('.select-subscribe-lang').find('.custom-select-name.active').length > 0
    ) {
        if (!e.target.closest('.custom-select-name')) {
            setTimeout(function(){
                $(".custom-select-name").removeClass("active");
            }, 500);
            $(".dropdown-menu").removeClass("active");
            $(".dropdown-menu-wrapper").slideUp( 500 );
        }
    }
})

$(document).on('contextmenu', 'img', (e) => {
    e.preventDefault();
});
$(document).on('dragstart', 'img', (e) => {
    e.preventDefault();
});

$(document).on('mousemove', (e) => {
    if ($('#fullscreen-gallery').hasClass('active')) {
        const $currentImage = $('.image-wrapper__img._active');
        const currentImageHeight = $currentImage.outerHeight();
        const windowHeight = $(window).outerHeight();
        if (currentImageHeight > windowHeight) {
            $currentImage.css({
                transform: 'translateY(-' + (e.pageY - $(window).scrollTop()) * (currentImageHeight / windowHeight - 1) + 'px)'
            });
        } else {
            $currentImage.css({
                transform: 'translateY(0)'
            });
        }
    }
});

$(document).on('click', '.thumbnails-wrapper__img', function (e) {
    e.preventDefault();
    $('.image-wrapper__img').removeClass('_active').eq($(this).index()).addClass('_active');
});

$(function () {
    $('.banner-catalog-flag').click(function (event) {
        event.preventDefault();
        let top = $("#settings").offset().top - $("header").outerHeight()
        $('html,body').animate({
            scrollTop: top
        }, 0);
    });
});

$(".custom-select").on('click', function (e) {
    if (
      $(e.target).hasClass('custom-select-name') &&
      Boolean(e.target.closest('.select-cart-size')) &&
      Boolean(e.target.closest('.select-subscribe-lang')) &&
      Boolean(e.target.closest('.unavailable'))
    ) {
        return false;
    }
    if ($(e.target).hasClass('custom-select-name') && !$(e.target).hasClass('custom-select-name active')) {
        $(".custom-select-name").removeClass("active");
        $(".dropdown-menu").removeClass("active");
        $(".dropdown-menu-wrapper").slideUp( 500 );
        $(this).find('.custom-select-name').toggleClass('active');
        $(this).find('.dropdown-menu').toggleClass('active');
        $(this).find(".dropdown-menu-wrapper").slideToggle( 500 );

    } else if ($(e.target).hasClass('custom-select-name') && $(e.target).hasClass('custom-select-name active')) {
        setTimeout(function(){
            $(".custom-select-name").removeClass("active");
        }, 500);
        $(".dropdown-menu").removeClass("active");
        $(".dropdown-menu-wrapper").slideUp( 500 );

    } else if ($(e.target).hasClass('dropdown-menu__item') && !$(e.target).hasClass('dropdown-menu__item dropdown-menu-range')) {
        $(e.target).toggleClass('active');

    }
    if (
      $(e.target).hasClass('dropdown-menu__item')
      && !Boolean(e.target.closest('.select-cart-size'))
      && !Boolean(e.target.closest('.select-subscribe-lang'))
    ) {
        filter()
    }
});

$(".select-cart-size").on('click', function(e) {
    if ($(e.target).hasClass('dropdown-menu__item') && $(e.target).hasClass('_disabled')) {
        return false;
    }
    if ($(e.target).hasClass('dropdown-menu__item')) {
        if ($(e.target).attr('id') !== 'custom_size' || localStorage.getItem("pintel_custom_size")) {
            $.each($(".dropdown-menu__item"), function () {
                $(this).removeClass('active');
            });
            $(e.target).addClass('active');
            $(this).find('.custom-select-name').html($(e.target).text());
            $(this).find('.custom-select-name').attr('data-size', $(e.target).text().trim());
            $(this).find('.custom-select-name').data('size', $(e.target).text().trim());
        } else {
            $(e.target).removeClass('active');
        }

        setTimeout(function(){
            $(".custom-select-name").removeClass("active");
        }, 500);
        $(".dropdown-menu").removeClass("active");
        $(".dropdown-menu-wrapper").slideUp( 500 );
    }
});

$(".select-subscribe-lang").on('click', function(e) {
    if ($(e.target).hasClass('dropdown-menu__item')) {
        $.each($(".dropdown-menu__item"), function () {
            $(this).removeClass('active');
        });
        $(e.target).addClass('active');
        $(this).find('.custom-select-name').html($(e.target).text());
        $(this).find('.custom-select-name').attr('data-lang', $(e.target).attr('id'));
        $(this).find('.custom-select-name').data('lang', $(e.target).attr('id'));

        setTimeout(function(){
            $(".custom-select-name").removeClass("active");
        }, 500);
        $(".dropdown-menu").removeClass("active");
        $(".dropdown-menu-wrapper").slideUp( 500 );
    }
});

$(document).ready(function () {
    let currentCurrency = localStorage.getItem('currentCurrency');
    let minPrice = $('#price-filter').attr(`data-min-${currentCurrency.toLowerCase()}`);
    let maxPrice = $('#price-filter').attr(`data-max-${currentCurrency.toLowerCase()}`);

    if ($("#js-range-slider").length) {
        $("#js-range-slider").ionRangeSlider({
            skin: "round",
            type: "double",
            min: minPrice,
            max: maxPrice,
            onFinish: () => filter(),
        });

        let rangeSliderData = $("#js-range-slider").data("ionRangeSlider");
        if ($("#range-sum-min").val() !== '') {
            rangeSliderData.update({
                from: $("#range-sum-min").val()
            });
        } else {
            $("#range-sum-min").attr('value', minPrice);
            rangeSliderData.update({
                from: minPrice,
            });
        }
        if ($("#range-sum-max").val() !== '') {
            rangeSliderData.update({
                to: $("#range-sum-max").val()
            });
        } else {
            $("#range-sum-max").attr('value', maxPrice);
            rangeSliderData.update({
                to: maxPrice,
            });
        }

        $("#js-range-slider").on("change", function () {
            var $inp = $(this);
            var from = $inp.data("from");
            var to = $inp.data("to");

            $("#range-sum-min").attr('value', from);
            $("#range-sum-max").attr('value', to);
        });
    }
})

$("#range-sum-min").on("input", function () {
    let rangeSliderData = $("#js-range-slider").data("ionRangeSlider");
    rangeSliderData.update({
        from: $(this).val()
    });
});

$("#range-sum-max").on("input", function () {
    let rangeSliderData = $("#js-range-slider").data("ionRangeSlider");
    rangeSliderData.update({
        to: $(this).val()
    });
});
const resetPriceFilter = () => {
    let currentCurrency = localStorage.getItem('currentCurrency');
    let minPrice = $('#price-filter').attr(`data-min-${currentCurrency.toLowerCase()}`);
    let maxPrice = $('#price-filter').attr(`data-max-${currentCurrency.toLowerCase()}`);

    $(".dropdown-menu__item").removeClass("active");
    let rangeSliderData = $("#js-range-slider").data("ionRangeSlider");
    rangeSliderData.update({
        min: minPrice,
        max: maxPrice,
        from: minPrice,
        to: maxPrice,
    });

    $("#range-sum-min").attr('value', minPrice);
    $("#range-sum-max").attr('value', maxPrice);

    filter();
};

$(".reset-btn").on('click', resetPriceFilter);

let request= "";

function filterParam(){
    let filterList = $(".form-settings .dropdown-menu");
    let settingsBtn = $(".settings-btn");
    let requestBtn = "";
    let PriceMin = "price_" + localStorage.getItem("currentCurrency") + "_min=" + $("#range-sum-min").val();
    let PriceMax = "price_" + localStorage.getItem("currentCurrency") + "_max=" + $("#range-sum-max").val();
    let requestPrice = "";
    let and = "&"
    request= ""

    $.each(filterList, function (index, value) {

        let filterListItem = $(this).children(".active")

        if ($(this).children(".active").length !== 0 && $(this).children(".active").length < 2) {
            request = request + and + value.dataset.category + "=";

            $.each(filterListItem, function (auIndex, suValue) {

                request = request + suValue.dataset.name;
                if (filterListItem.length-1 === index){

                    return false
                }
            });
        }else if($(this).children(".active").length !== 0 && $(this).children(".active").length >1){
            request = request + and + value.dataset.category + "=";

            $.each(filterListItem, function (auIndex, suValue) {
                if (filterListItem.length-1 === auIndex){
                    request = request + suValue.dataset.name;
                    return false
                }else{
                    request = request + suValue.dataset.name + ",";
                }


            });
        }

        if (filterList.length - 1 === index) {

            return false
        }

    });

    $.each(settingsBtn, function (index, value) {
        let valueAttr = value.getAttribute("data-ordering");
        if(valueAttr === "-final_price" && value.classList.contains("_active")
            || valueAttr === "final_price" && value.classList.contains("_active")){
            if(localStorage.getItem("currentCurrency") !== null){
                requestBtn = and + "ordering=" + valueAttr + "_" + localStorage.getItem("currentCurrency")
                return false
            }else{
                requestBtn = and + "ordering=" + valueAttr +"_eur"
                return false
            }
        }
        else if(value.classList.contains("_active")){
            requestBtn = and + "ordering=" + valueAttr
            return false
        }
    });

    if(localStorage.getItem("currentCurrency") !== null){
        requestPrice = and + PriceMin + and + PriceMax
    }else{
        requestPrice = and + "price_" + "eur" + "_min=" + $("#range-sum-min").val()
            + and + "price_" + "eur" + "_max=" + $("#range-sum-max").val();
    }

    request = request + requestBtn + requestPrice;

    request = request.replace('&', '', 1);

    return request

}

function filter() {

    filterParam()


    let urlOrigin = window.location.origin;
    let urlPathname = window.location.pathname;

    let locale = urlPathname.substring(0, 3)
    let urlPathnameWithoutLocale = urlPathname.substring(3)
    let newUrl = urlOrigin + locale + "/filter" + urlPathnameWithoutLocale + "?" + request;

    history.replaceState(null, null, ' ');
    window.history.pushState("string", "search", "?" + request);

    $(".change-lang-form").find('input[name="next"]').val(urlPathnameWithoutLocale + "?" + request);
    $.ajax({
        url: newUrl, async: false, success: function (result) {
            $(".catalog-gallery").html(result)

        }
    });
    currency($(".price"));
    currency($(".sale"));
}

function currency(arr){
    if(localStorage.getItem("currentCurrency") !== null){
        $.each(arr, function (index, value) {
            value.classList.remove("_active")
            if(value.getAttribute("data-currency") === localStorage.getItem("currentCurrency")){
                value.classList.add("_active")
            }
        });
    }
}

currency($('.button-currency'));
currency($(".flag"));
currency($(".price"));
currency($(".sale"));

const getFedexCost = () => {
    const currency = localStorage.getItem("currentCurrency");
    let cost;
    const usdRate = JSON.parse(localStorage.getItem("rates")).usd;
    const bynRate = JSON.parse(localStorage.getItem("rates")).byn;
    const rubRate = JSON.parse(localStorage.getItem("rates")).rub;

    const deliveryCountry = $('#checkout__form')
      .find('#shipping-select-country')
      .parent()
      .find('.choices__item.choices__item--selectable')
      .attr('area-selected', true)
      .data('value');

    const USAndCACountries = ['United States of America', 'Canada'];
    const RUCountry = ['Russian Federation', 'Belarus'];
    const EUCountries = [
        'Austria',
        'Belgium',
        'Bulgaria',
        'Croatia',
        'Cyprus',
        'Czechia',
        'Denmark',
        'Estonia',
        'Finland',
        'France',
        'Germany',
        'Greece',
        'Hungary',
        'Ireland',
        'Italy',
        'Latvia',
        'Lithuania',
        'Luxembourg',
        'Malta',
        'Netherlands',
        'Poland',
        'Portugal',
        'Romania',
        'Slovakia',
        'Slovenia',
        'Spain',
        'Sweden',
        'United Kingdom of Great Britain and Northern Ireland',
    ];

    const getCostHelper = (currency) => {
        if ($.inArray(deliveryCountry, USAndCACountries) !== -1) {
            return cost = Math.round(310 * currency);
        } else if ($.inArray(deliveryCountry, RUCountry) !== -1) {
            return cost = Math.round(150 * currency);
        } else if ($.inArray(deliveryCountry, EUCountries) !== -1) {
            return cost = Math.round(230 * currency);
        } else return cost = Math.round(360 * currency);
    }

    switch (currency) {
        case 'eur':
            return getCostHelper(1);
        case 'usd':
            return getCostHelper(usdRate);
        case 'rub':
            return getCostHelper(rubRate);
        case 'byn':
            return getCostHelper(bynRate);
        default:
            return getCostHelper(1);
    }
};

const changeCheckoutCosts = () => {
    if ($('#checkout__form').length) {

        const currency = localStorage.getItem("currentCurrency");

        $('#checkout__form')
          .find('#fedex-delivery')
          .attr('data-cost', getFedexCost());
        $('#checkout__form')
          .find('#fedex-delivery')
          .data('cost', getFedexCost());
        $('#checkout__form')
          .find('#fedex-delivery')
          .find('.fedex-cost')
          .html(`${getFedexCost()} ${currency.toUpperCase()}`);

        if ($('.delivery-type[data-checked="checked"]').data('delivery') === 'fedex') {
            $('.buy-information')
              .find('.discount')
              .html(`FedEx Priority — ${getFedexCost()} ${currency.toUpperCase()}`);

            const itemsSum = $(".buy-information").find(".price._active").data('sum');
            $(".buy-information").find(".price._active").find(".amount").replaceWith(`<span class="amount">${Number(getFedexCost()) + Number(itemsSum)}</span>`);
        }
    }
};

changeCheckoutCosts();

$(function () {
    $('.button-currency').click(function (event) {
        event.preventDefault();

        let target = event.target;

        $('.button-currency').removeClass("_active");
        target.classList.add("_active");

        let currentCurrency = target.getAttribute("data-currency");
        let flagCurrencyList = $(".flag");

        $.each(flagCurrencyList, function (index, value) {
            value.classList.remove("_active")
            if(value.getAttribute("data-currency") === currentCurrency){
                value.classList.add("_active")
            }
        });
        localStorage.setItem("currentCurrency", currentCurrency);
        currency($(".price"));
        currency($(".sale"));
        changeCheckoutCosts();

        resetPriceFilter();

        let urlSearch = window.location.search
        let pageNum = urlSearch.split("page=")[1] !== undefined ? urlSearch.split("page=")[1] : urlSearch.split("page=")[2]

        if (pageNum !== undefined){
            request = request + "&page=" + pageNum;
        }

        history.replaceState(null, null, ' ');
        window.history.pushState("string", "search", "?" + request);

        return currentCurrency

    });
});

$(document).ready(function () {
    const catalogItemsRequest = (url, page) => {
        $.ajax({
            url: url, async: false, success: function (result) {
                if (page === '1') {
                    $('#catalog-banner').css("display", "block");
                    const pageHeight = window.innerHeight;
                    window.scrollTo({
                        top: window.innerWidth > 1025 ? pageHeight - 93 : pageHeight,
                        left: 0,
                        behavior: "instant",
                    });
                } else {
                    $('#catalog-banner').css("display", "none");
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                    });
                }
                $(".catalog-gallery").html(result);
                currency($(".price"));
            }
        });
    }

    $("body").on('click', ".pages-items", (e) => {
        filterParam()
        let dataPge
        let urlOrigin = window.location.origin;
        let urlPathname = window.location.pathname;

        let locale = urlPathname.substring(0, 3)
        let urlPathnameWithoutLocale = urlPathname.substring(3)
        let pageUrl = urlOrigin + locale + "/filter" + urlPathnameWithoutLocale + "?";

        if(e.target.closest('.page') && !e.target.closest('.active')){
            e.preventDefault()
            dataPge = e.target.closest('.page').getAttribute("data-page");
            let urlSearchPage = request + "&page=" + dataPge;
            pageUrl = pageUrl + urlSearchPage
           /* console.log(urlSearchPage)*/
            history.replaceState(null, null, ' ');
            window.history.pushState("string", "search", "?"+ urlSearchPage);
            $(".change-lang-form").find('input[name="next"]').val(urlPathnameWithoutLocale + "?" + urlSearchPage);

            catalogItemsRequest(pageUrl, dataPge);
        } else if(e.target.closest('.more')){
            dataPge = e.target.closest('.more').getAttribute("data-page")
            let urlSearchPage = request + "&page=" + dataPge
            pageUrl = pageUrl + urlSearchPage

            history.replaceState(null, null, ' ');
            window.history.pushState("string", "search", "?"+ urlSearchPage);

            $(".change-lang-form").find('input[name="next"]').val(urlPathnameWithoutLocale + "?" + urlSearchPage);
            catalogItemsRequest(pageUrl, dataPge);
        }
    })

    if (window.history && window.history.pushState) {
        $(window).on('popstate', function() {
            const hashLocation = location.hash;
            const hashSplit = hashLocation.split("#!/");
            const hashName = hashSplit[1];

            if (hashName !== '') {
                const hash = window.location.hash;
                if (hash === '') {
                    let urlOrigin = window.location.origin;
                    let urlPathname = window.location.pathname;
                    let locale = urlPathname.substring(0, 3)
                    let urlPathnameWithoutLocale = urlPathname.substring(3);

                    const urlSearch = window.location.search;
                    const urlParams = new URLSearchParams(window.location.search);
                    const pageNumber = urlParams.get('page');

                    const requestUrl = urlOrigin + locale + "/filter" + urlPathnameWithoutLocale + urlSearch;

                    catalogItemsRequest(requestUrl, pageNumber);
                }
            }
        });
    }
});

const getCountriesForSelect = () => {
    const countryList = [
        "Afghanistan",
        "Aland Islands",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory",
        "British Virgin Islands",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos Islands",
        "Colombia",
        "Comoros",
        "Cook Islands",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Democratic Republic of the Congo",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine Territory",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation",
        "Rwanda",
        "Reunion",
        "Saint Barthelemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "U.S. Virgin Islands",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom of Great Britain and Northern Ireland",
        "United States Minor Outlying Islands",
        "United States of America",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Viet Nam",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ];

    const countryOptions = countryList.map((country) => ({ value: country, label: country, selected: false }));
    const countryOptionsSelected = (countryName) => (
      countryList.map((country) => ({ value: country, label: country, selected: country === countryName }))
    );

    return {
        countryOptions,
        countryOptionsSelected,
    }
}

const choicesCheckoutHandle = (choicesElement) => {
    if ($("#checkout__form").length) {
        changeCheckoutCosts();
        choicesElement.addEventListener(
          'change',
          function() {
              changeCheckoutCosts();
              if ($(this).attr('id') === 'shipping-select-country') {
                  if ($(this).find('option').html() !== $('#billing-select-country').find('option').html()) {
                      $('#same-addresses-checkbox').prop('checked', false);
                  }
              } else if ($(this).attr('id') === 'billing-select-country') {
                  if ($(this).find('option').html() !== $('#shipping-select-country').find('option').html()) {
                      $('#same-addresses-checkbox').prop('checked', false);
                  }
              }
          }
        );
    }
}

const listSelect = () => {
    const { countryOptions, countryOptionsSelected } = getCountriesForSelect();
    const list = document.querySelectorAll('.select-list.no-selected');
    list.forEach((el) => {
        const choices = new Choices(el, {
            choices: countryOptions,
            searchEnabled: true,
            placeholder: true,
            shouldSort: false,
            searchResultLimit: 10000,
            position: "bottom",
            allowHTML: true,
            classNames: {
                containerOuter: 'choices-as-list',
            },
            fuseOptions: {
                threshold: 0.1,
                distance: 1000,
            }
        });

        choicesCheckoutHandle(choices.passedElement.element);
    });

    const listHasSelected = document.querySelectorAll('.select-list.has-selected');
    listHasSelected.forEach((el) => {
        const choices = new Choices(el, {
            choices: countryOptionsSelected(el.dataset.selectedcountry),
            searchEnabled: true,
            placeholder: true,
            shouldSort: false,
            searchResultLimit: 10000,
            position: "bottom",
            allowHTML: true,
            classNames: {
                containerOuter: 'choices-as-list',
            },
            fuseOptions: {
                threshold: 0.1,
                distance: 1000,
            }
        });

        choicesCheckoutHandle(choices.passedElement.element);
    });
}

listSelect();

$('.my-addresses-menu').on('click', function (e) {
    const $shippingAddressFields = $('.address-form__fieldset.delivery-address');
    const $billingAddressFields = $('.address-form__fieldset.billing-address');
    const menu = $(this).find('.my-addresses-wrapper');

    if ($(e.target).closest('.my-address-card').length) {
        $.each(menu.find('.my-address-card'), function() {
            $(this).removeClass('chosen-address');
        });
        $(e.target).closest('.my-address-card').addClass('chosen-address');

        const dataAttrs = $(e.target).closest('.my-address-card').data();
        const fields = Object.entries(dataAttrs).map(([objKey, value]) => ({
            name: objKey,
            value
        }));

        if (menu.attr('id') === 'my-shipping-addresses') {
            $shippingAddressFields.find('input').each(function() {
                fields.forEach(({ name, value }) => {
                    if (name === 'country') {
                        $shippingAddressFields.find('.choices-as-list').remove();
                        $shippingAddressFields.find('.form-group_country').append(
                          `<select name="country" class="select-list address-form__field required has-selected" id="shipping-select-country" data-selectedCountry="${value}"></select>`
                        );
                        listSelect();
                        changeCheckoutCosts();
                    } else {
                        name === $(this).attr('name') && $(this).val(value);
                    }
                });
            });

            $shippingAddressFields.find('._error').removeClass('_error');
        }

        if (menu.attr('id') === 'my-billing-addresses') {
            $billingAddressFields.find('input').each(function() {
                fields.forEach(({ name, value }) => {
                    if (name === 'country') {
                        $billingAddressFields.find('.choices-as-list').remove();
                        $billingAddressFields.find('.form-group_country').append(
                          `<select name="country" class="select-list address-form__field required has-selected" id="billing-select-country" data-selectedCountry="${value}"></select>`
                        );
                        listSelect();
                    } else {
                        name === $(this).attr('name') && $(this).val(value);
                    }
                });
            });

            $billingAddressFields.find('._error').removeClass('_error');
        }

        $('#same-addresses-checkbox').prop('checked', false);
    }
});

if ($('.buy-form').length) {
    const deliveryOptions = $('.delivery-type');
    deliveryOptions.click(function() {
        $('.buy-information').find('.discount').html($(this).text());

        deliveryOptions.each(function() {
            $(this).removeAttr('data-checked');
        });

        $(this).attr('data-checked', 'checked');
        $(this).data('checked', 'checked');

        const itemsSum = $(".buy-information").find(".price._active").data('sum');

        if ($('.delivery-type[data-checked="checked"]').data('delivery') === 'fedex') {
            $(".buy-information")
              .find(".price._active")
              .find(".amount")
              .replaceWith(`<span class="amount">${Number(getFedexCost()) + Number(itemsSum)}</span>`);
        } else $(".buy-information")
          .find(".price._active")
          .find(".amount")
          .replaceWith(`<span class="amount">${Number(itemsSum)}</span>`);
    })
}

if ($('#checkout__form').length) {
    const $sameAddresses = $('#same-addresses-checkbox');
    const $shippingAddressFields = $('.address-form__fieldset.delivery-address');
    const $billingAddressFields = $('.address-form__fieldset.billing-address');

    $sameAddresses.on('change', function(e) {
        if (e.target.checked) {
            let fields = [];
            $shippingAddressFields.find('input').each(function() {
                if ($(this).attr('name') !== 'search_terms') {
                    fields.push({name: $(this).attr('name'), value: $(this).val()});
                }
            });

            $billingAddressFields.find('input').each(function() {
                fields.forEach(({ name, value }) => {
                    name === $(this).attr('name') && $(this).val(value);
                });
            });

            const $country = $shippingAddressFields.find('select[name="country"]').find('option').html();
            $billingAddressFields.find('.choices-as-list').remove();
            $billingAddressFields.find('.form-group_country').append(
              `<select name="country" class="select-list address-form__field required has-selected" id="billing-select-country" data-selectedCountry="${$country}"></select>`
            );
            listSelect();
        }
    });

    $billingAddressFields.find('input').each(function(billIndex, billingInput) {
        $(billingInput).on('change', function(event) {
            const shippingInputValue = $shippingAddressFields.find(`input[name="${$(this).attr('name')}"]`).val();
            if (event.target.value !== shippingInputValue) {
                $sameAddresses.prop('checked', false)
            }
        })
    });

    $shippingAddressFields.find('input').each(function(shipIndex, shipInput) {
        $(shipInput).on('change', function(event) {
            const billingInputValue = $billingAddressFields.find(`input[name="${$(this).attr('name')}"]`).val();
            if (event.target.value !== billingInputValue) {
                $sameAddresses.prop('checked', false)
            }
        });
    });
}

const hideArrowOnScroll = (element) => {
    if (element) {
        if (window.scrollY > 100) {
            element.css("opacity", 0);
        } else element.css("opacity", 1);

        $(window).scroll(function() {
            element.css("opacity", 1 - $(window).scrollTop() / 600);
        });
    }
}

hideArrowOnScroll($('.banner-catalog-flag'));
hideArrowOnScroll($('.about-image__flag'));
hideArrowOnScroll($('.editorial-year__flag'));

/*let customSelectName = document.querySelectorAll(".custom-select-name");

customSelectName.forEach((el)=>{
    el.addEventListener("click",function (){
        $(this).siblings().slideToggle( "slow" );
    })
})*/

